import * as React from 'react' 
import { Spinner } from 'react-bootstrap'
import { FaSpinner } from 'react-icons/fa'


export function LoadingSpinner() {

    return <div className='spinner'><Spinner /></div>
}